<div *ngIf="enhancedOrgTreeModel" class="org-heirarchy" [ngClass]="{ 'org-heirarchy--popover': isPopover }">
  <div>
    <ion-row>
      <ng-container *ngIf="showDesc; else showTitle">
        <ion-col class="org-heirarchy__description" size="9">
          <div>{{ 'org_hierarchy.Expand/CollapseToSelect' | translate }}</div>
        </ion-col>
      </ng-container>
      <ng-template #showTitle>
        <ion-col class="org-heirarchy__title">
          <div>{{ title }}</div>
        </ion-col>
      </ng-template>
      <ion-col class="org-heirarchy__btns">
        <span *ngIf="showClear" class="org-heirarchy__clear">
          <ui-custom-button
            [buttonType]="'SECONDARY'"
            [btnTxt]="'org_hierarchy.Clear' | translate"
            (clickEvent)="onClear()"
          ></ui-custom-button>
        </span>
        <span *ngIf="showApply">
          <ui-custom-button
            [buttonType]="'PRIMARY'"
            [btnTxt]="'org_hierarchy.Apply' | translate"
            (clickEvent)="onApply()"
          ></ui-custom-button>
        </span>
      </ion-col>
    </ion-row>
  </div>
  <div>
    <ul>
      <ng-container *ngFor="let treeValue of enhancedOrgTreeModel.orgTreeModel.values">
        <ng-container *ngIf="treeValue.children && treeValue.children.nodes">
          <ul>
            <ng-container
              *ngTemplateOutlet="
                recursiveListTmpl;
                context: { list: treeValue.children.nodes, parent: treeValue.children.displayName }
              "
            ></ng-container>
          </ul>

          <ng-template #recursiveListTmpl let-list="list" let-parent="parent">
            <li *ngFor="let item of list">
              <ion-row
                class="org-heirarchy__node-row"
                [ngClass]="{
                  'org-heirarchy__node-row--selected':
                    showActiveNode &&
                    enhancedOrgTreeModel.selectedNode &&
                    enhancedOrgTreeModel.selectedNode.data.enhancedNodeInfo.id === item.enhancedNodeInfo.id
                }"
                (click)="onNodeSelection(item)"
              >
                <ion-col size="11">
                  <div
                    *ngIf="item.children && item.children.nodes.length"
                    (click)="collapseExpandNode(item)"
                    class="org-heirarchy__node-toggle"
                  >
                    <span *ngIf="item.enhancedNodeInfo.isMinimized; else nodeExpanded">
                      <img src="assets/common/expand-plus.svg" />
                    </span>
                    <ng-template #nodeExpanded>
                      <span>
                        <img class="org-heirarchy__collapse-minus-icon" src="assets/common/collapse-minus.svg" />
                      </span>
                    </ng-template>
                  </div>
                  <span>{{ parent }}: {{ item.value }}</span>
                </ion-col>
                <ion-col size="1" *ngIf="hasMultiSelectSupport" class="ion-text-end">
                  <ion-checkbox [checked]="item.enhancedNodeInfo.isSelected"></ion-checkbox>
                </ion-col>
              </ion-row>
              <ul *ngIf="item.children && !item.enhancedNodeInfo.isMinimized">
                <ng-container
                  *ngTemplateOutlet="
                    recursiveListTmpl;
                    context: { list: item.children.nodes, parent: item.children.displayName }
                  "
                ></ng-container>
              </ul>
            </li>
          </ng-template>
        </ng-container>
      </ng-container>
    </ul>
  </div>
</div>
